import React, { Component } from 'react';
import Helmet from 'react-helmet';
import Header from './Header';
import Footer from '../../components/Footer/Footer';
import Join from '../../components/JoinModal/JoinModal';
import Modal from '../../components/Modal/Modal';

class CallCenter extends Component {
  state = {
    modal: false
  }
  render() {
    const styles = require('./CallCenter.less');

    return [
      <Helmet
        key="0"
        htmlAttributes={{ lang: 'ru-RU' }}
        title="Call Center и клиентская поддержка онлайн сервиса для создания опросов и сбора отзывов (обратной связи) / оценок и аналитики от Клиентов (ЦА) – Mvoter.com"
        meta={[{ name: 'description', content: 'Customer Support / Call Center MVoter – Онлайн платформа для создания моментальной обратной связи с Клиентами! Онлайн сервис по сбору отзывов ✓ Анализ обратной связи от ЦА и потребителей ✓ Управление удовлетворенностью клиентов ✓ Отрасли использования опросника: Рестораны, Банки, Здравоохранение, Торговля, Общественный транспорт ☎ +7 (747) 359-5959' }]}
      />,
      <Header key="1" />,
      <div key="2" className={ styles.content }>
        <div className={ styles.inner }>
          <div className={ styles.wrap }>
            <h1>Call Center и Клиентская поддержка MVoter</h1>
            <p>Клиентам MVoter предоставляется кабинет с собственным колл-центром, который позволяет оперативно взаимодействовать с клиентами оставившими свои отзывы и пожелания на ваши товары или услуги.</p>
            <p style={{ marginBottom: '80px' }}>Гибкая система обратной связи MVoter позволят связываться с клиентами и решать возникшие вопросы наиболее удобными для вас и клиентов способами: с помощью пост-звонка на мобильное приложение MVoter, письмо на электронный ящик, автоматические SMS сообщения или персональная переписка в чате MVoter. Методы связи можно комбинировать для оптимизации сбора данных. Отчетность предоставляется по отдельным операторам, каналам связи, продуктам/услугам, регионам и т. д.</p>
            <div className={ styles.rowWrap }>
              <div className={ styles.rowItem }>
                <div className={ styles.leftSide }>
                  <img src="./images/callcenter/1.svg" width="390" height="294" />
                </div>
                <div className={ styles.rightSide }>
                  <h4>Интеграция/IVR/запись разговоров</h4>
                  <p>В целях повышения качества обслуживания все разговоры с клиентами записываются в автоматическом режиме. Компании-клиенты могут в любой момент иметь доступ к базе звонков. В случае необходимости колл-центр MVoter можно интегрировать с системами интерактивных голосовых ответов (IVR). Интегрировать MVoter с вашим существующим колл-центром (контакт-центром) очень легко, просто переведите все сигналы и вызовы из MVoter в вашу телефонную(контакт) систему.</p>
                </div>
              </div>
              <div className={ styles.rowItem }>
                <div className={ styles.rightSide }>
                  <h4>СМС сообщения</h4>
                  <p>После каждой оценки ваших услуг/товаров ваши клиенты могут получать СМС сообщения. Содержание автоматически рассылаемых сообщений может отличаться в зависимости от того какую оценку поставили ваши клиенты.</p>
                </div>
                <div className={ styles.leftSide }>
                  <img src="./images/callcenter/2.svg" width="380" height="324" />
                </div>
              </div>
              <div className={ styles.rowItem }>
                <div className={ styles.leftSide }>
                  <img src="./images/callcenter/3.svg" width="380" height="325" />
                </div>
                <div className={ styles.rightSide }>
                  <h4>Чат MVoter</h4>
                  <p>В зависимости от особенностей вашего бизнеса или конкретного случая, вы можете перейти в модуль чат-переписки с вашими клиентами. Вся история сообщений в чат-переписке с клиентами хранится на серверах MVoter не менее 12 месяцев.</p>
                </div>
              </div>
            </div>
            <h3>Создайте систему обратной связи сейчас. Это просто.</h3>
            <ul className={ styles.buttons }>
              <li><span onClick={ () => this.setState({ modal: true }) }>Регистрация</span></li>
              <li><span onClick={ () => this.setState({ modal: true }) }>Запросить демонстрацию</span></li>
            </ul>
          </div>
        </div>
        { this.state.modal
          && (
            <Modal
              title="Запросить демонстрацию"
              content={ <Join onCloseClick={ () => this.setState({ modal: false }) } /> }
              onCloseClick={ () => this.setState({ modal: false }) }
            />
          )}
      </div>,
      <Footer key="3" subId="page" />
    ];
  }
}

export default CallCenter;
